/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import withTranslations from 'app/components/HOGs/withTranslations';

import { Input, Slider, Tooltip, Divider, message } from 'antd';
import { DownOutlined, UpOutlined, ReloadOutlined } from '@ant-design/icons';

import { FormattedMessage, useIntl } from 'react-intl';

import * as types from 'actions/action_types';

import pointStart from 'static/images/icons/tour_finder_start.svg';
import pointEnd from 'static/images/icons/tour_finder_end.svg';

import * as way from 'app/libs/core/PubSubWays';
import mapUtils from 'app/libs/Utils/mapUtils';
import { setMapFilter } from 'app/actions/FullTour/full_tour_view.action';
import { getCustomId } from 'app/libs/core/Unique';

import './filters.css';

import { setTypeMouseCursor } from 'actions/Core/css.effect.action';

import { publish } from '../../../libs/core/PubSub';
import {
  AreaFilterIcon,
  ScenicSvg,
  SeasideSvg,
  StraightSvg,
  TwistedSvg,
  MountainSvg,
} from '../MainMenu/svg';
import AutoCompleteAddressSearch from '../../Utility/autocompleteAddressSearch';
import tourPrevAPI from '../../../API/tour.prev.api';
import {
  converteDistanceByType,
  detectArrowTypeCode,
} from '../../Utility/utility';
import { StarFilledIcon } from '../TourstartAcademy/academy.svg';
import ttf from '../../../../static/img/Tourstart_Tour_Finder_v1.svg';

let mainData = null;
let startId = null;
let endId = null;
let polyId = null;
let close = null;
let slide = null;
let areaId = null;

const Filters = ({ page, children, suggest = null, tr }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { data } = useSelector((store) => store.mapDataReducer);
  const { coord } = useSelector((store) => store.mapPostition);

  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState([]);
  const [star, setStar] = useState(false);
  const [value, setValue] = useState([0, 1000]);
  const [range, setRange] = useState([0, 1000]);
  const [search, setSearch] = useState(false);
  const [loc, setLoc] = useState(null);
  const [map, setMap] = useState(false);
  const [addressTip, setAddressTip] = useState('');
  const [activePoint, setActivePoint] = useState(null);
  const [activePolyes, setActivePolyes] = useState([]);
  const [startCoord, setStartCoord] = useState(null);
  const [endCoord, setEndCoord] = useState(null);

  const ref = useRef(null);

  const resetFilterObjects = () => {
    dispatch(setMapFilter(false));
    setMap(false);
    setActivePoint(null);
    setStartCoord(null);
    setEndCoord(null);
    publish(way.HIDE_FILTER_POLYLINE, {});
    publish(way.HIDE_FILTER_MAIN_POLYLINE, {});
    publish(way.CLEAR_FILTER_POINTS, {});
    startId = null;
    endId = null;
    polyId = null;
    areaId = null;
    if (!suggest) {
      dispatch(setTypeMouseCursor(''));
    }
  };

  useEffect(() => {
    if (page === 'list') {
      setVisible(true);
    }

    return () => {
      resetFilterObjects();
      dispatch({ type: types.MAP_DATA_INITIAL_STATE });
    };
  }, []);

  const updateFilterAlternativePoly = (data) => {
    publish(way.HIDE_FILTER_POLYLINE, {});
    const arrRoutes = [];
    activePolyes.forEach((item) => {
      data.forEach((i) => {
        if (i.id === item.id) {
          arrRoutes.push(item);
        }
      });
    });
    publish(way.SHOW_FILTER_ALTERNATIVE_POLYLINES, { list: arrRoutes });
  };

  useEffect(() => {
    if (activePolyes && activePolyes.length > 0 && (startCoord || endCoord)) {
      updateFilterAlternativePoly(data);
    }
    if (data && data.length > 0 && !mainData) {
      mainData = suggest || data;
    }
  }, [data]);

  const showRoute = (data) => {
    const points = [
      [startCoord.lat, startCoord.lng],
      [endCoord.lat, endCoord.lng],
    ];
    if (polyId) {
      publish(way.HIDE_FILTER_MAIN_POLYLINE, {});
    }
    publish(way.SHOW_FILTER_POLYLINE, { points });
    polyId = getCustomId();

    if (data.alternatives) {
      const arrRoutes = [];
      const arrTour = [];
      data.alternatives.forEach((item) => {
        mainData.forEach((i) => {
          if (i.id === item.id) {
            item.geometry = mapUtils.decodePath(item.geometry);
            arrRoutes.push(item);
            arrTour.push(i);
          }
        });
      });
      publish(way.SHOW_FILTER_ALTERNATIVE_POLYLINES, { list: arrRoutes });
      setLoc(arrTour);
      setActivePolyes(arrRoutes);
    }
  };

  useEffect(() => {
    if (startCoord && endCoord) {
      const { lat: latS, lng: lngS } = startCoord;
      const { lat: latE, lng: lngE } = endCoord;
      const options = {};
      options.overview = 'full';
      options.path = `${lngS},${latS};${lngE},${latE}`;
      mapUtils.getOSMDirectionsService(options, showRoute, {
        getAlt: true,
        altPath: `${lngS},${latS};${lngE},${latE}`,
        fromFilter: true,
      });
    }
  }, [startCoord, endCoord]);

  const addPoint = (lat, lng, activePoint) => {
    const id = activePoint === 'start' ? startId : endId;
    if (id) {
      publish(way.REMOVE_FILTER_POINT, { customId: id });
    }
    const custom = getCustomId();

    if (activePoint === 'start') {
      startId = custom;
    } else {
      endId = custom;
    }

    publish(way.ADD_FILTER_POINT, {
      customId: custom,
      isLoading: false,
      point: {
        lat,
        lng,
        draggable: true,
        type: `finder_${activePoint}`,
        iconType: `finder_${activePoint}`,
      },
    });
  };

  const getStartRoutes = (props) => {
    const { rel, type } = props;
    const { lat, lng } = rel;

    tourPrevAPI.sortByLoc(`${lng},${lat}`, type).then((res) => {
      setSearch(true);
      publish(way.DRIVE_BUILDER_MOVE_MAP, { latLng: { lat, lng }, zoom: 10 });
      const arrRoutes = [];
      const arrTour = [];
      res.forEach((item) => {
        mainData.forEach((i) => {
          if (i.id === item.id) {
            item.geometry = mapUtils.decodePath(item.geometry);
            if (type === 'end') {
              const lastPoint = item.geometry[item.geometry.length - 1];
              i.lat = lastPoint[0];
              i.lng = lastPoint[1];
            }
            arrRoutes.push(item);
            arrTour.push(i);
          }
        });
      });
      publish(way.SHOW_FILTER_ALTERNATIVE_POLYLINES, { list: arrRoutes });
      setLoc(arrTour);
      setActivePolyes(arrRoutes);
    });
  };

  const searchOnArea = (props) => {
    const { rel, children } = props;
    const { lat, lng } = rel;
    tourPrevAPI.sortByLoc(`${rel.lng},${rel.lat}`, 'public').then((res) => {
      const arrTour = [];
      res.forEach((item) => {
        mainData.forEach((i) => {
          if (i.id === item.id) {
            arrTour.push(i);
          }
        });
      });
      setLoc(arrTour);
      setAddressTip(children);
      setSearch(true);
      publish(way.DRIVE_BUILDER_MOVE_MAP, { latLng: { lat, lng }, zoom: 10 });
      if (areaId) {
        publish(way.REMOVE_FILTER_POINT, { customId: areaId });
      }
      areaId = getCustomId();
      publish(way.ADD_FILTER_POINT, {
        customId: areaId,
        isLoading: false,
        point: {
          lat,
          lng,
          draggable: true,
          type: `finder_area`,
          iconType: `finder_area`,
        },
      });
    });
  };

  function getAddress({ lat, lng }) {
    mapUtils.getTourstartGeocoder({ lat, lng, id: 1 }, (e) => {
      const address = mapUtils.formateTourstartAddress(e.data);
      ref.current.update(address);
      searchOnArea({ rel: { lat, lng }, children: address });
    });
  }

  useEffect(() => {
    if (coord && coord.lat && coord.lng && map && !coord.type) {
      const { lat, lng } = coord;
      addPoint(lat, lng, activePoint);
      if (activePoint === 'start') {
        if (!endCoord) {
          dispatch(setMapFilter('start'));
          dispatch(setTypeMouseCursor('cursor_finder_end'));
          setActivePoint('end');
          getStartRoutes({ rel: coord, type: 'start' });
        } else {
          publish(way.HIDE_FILTER_POLYLINE, {});
          dispatch(setTypeMouseCursor(''));
          setActivePoint(null);
          setMap(false);
        }
        setStartCoord(coord);
      } else if (activePoint === 'end') {
        if (!startCoord) {
          dispatch(setMapFilter('end'));
          dispatch(setTypeMouseCursor('cursor_finder_start'));
          setActivePoint('start');
          getStartRoutes({ rel: coord, type: 'end' });
        } else {
          publish(way.HIDE_FILTER_POLYLINE, {});
          dispatch(setTypeMouseCursor(''));
          setActivePoint(null);
          setMap(false);
        }
        setEndCoord(coord);
      }
    }
    if (coord && coord.type) {
      if (coord.type === 'finder_start') {
        setStartCoord(coord);
      } else if (coord.type === 'finder_end') {
        setEndCoord(coord);
      } else if (coord.type === 'finder_area') {
        getAddress(coord);
      }
    }
  }, [coord]);

  function takeAddressByClickMap() {
    setActivePoint(null);
    setMap(false);
    dispatch(setTypeMouseCursor('cursor_finder_area'));
    publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_ON, (e) => {
      const { lat, lng } = e.latlng;
      if (areaId) {
        publish(way.REMOVE_FILTER_POINT, { customId: areaId });
      }
      areaId = getCustomId();
      publish(way.ADD_FILTER_POINT, {
        customId: areaId,
        isLoading: false,
        point: {
          lat,
          lng,
          draggable: true,
          type: `finder_area`,
          iconType: `finder_area`,
        },
      });
      getAddress(e.latlng);
      publish(way.CLUB_EDIT_GET_ADDRESS_FROM_MAP_OFF);
      dispatch(setTypeMouseCursor(''));
    });
  }

  const saveToRedux = (data) => {
    dispatch(
      suggest
        ? {
            type: types.TOUR_FULL_ROUTE_SUGGESTION,
            payload: data,
          }
        : {
            type: types.FETCH_TOURS_PUBLIC_FULFILLED,
            payload: data,
          }
    );
  };

  useEffect(() => {
    if (mainData && mainData.length > 0) {
      let arr = mainData;

      if (loc) {
        arr = loc;
      }

      if (active.length > 0) {
        const sum = [];
        arr.forEach((item) => {
          const type = detectArrowTypeCode(item.arrow_type);
          type.forEach((i) => {
            if (active.includes(i) && !sum.includes(item)) {
              sum.push(item);
            }
          });
        });
        arr = sum;
      }

      if (star) {
        arr = arr.filter((item) => item.star);
      }

      if (value) {
        arr = arr.filter((item) => {
          if (value[1] > 999) {
            return converteDistanceByType('km', item.distance) >= value[0];
          }
          return (
            converteDistanceByType('km', item.distance) >= value[0] &&
            converteDistanceByType('km', item.distance) <= value[1]
          );
        });
      }

      if (arr.length === 0 && !close) {
        close = message.warning(
          intl.formatMessage({
            id: 'No result found',
            defaultMessage: 'No result found',
          }),
          1.5,
          () => {
            close = null;
          }
        );
      }
      saveToRedux(arr);
    }
  }, [loc, active, star, value]);

  const getLayoutClass = () =>
    visible ? 'filter_layout visible' : 'filter_layout';

  const getItemClass = (num) =>
    active.includes(num) ? 'filter_items active' : 'filter_items';

  const onActive = (num) => {
    const activeData = [...active];
    const index = activeData.indexOf(num);
    if (index > -1) {
      activeData.splice(index, 1);
    } else {
      activeData.push(num);
    }
    setActive(activeData);
  };

  const starClick = () => {
    setStar(!star);
  };

  const onChnageRange = (value) => {
    setRange(value);
    if (slide) {
      clearTimeout(slide);
    }
    slide = setTimeout(() => {
      setValue(value);
    }, 1000);
  };

  const onReset = (e) => {
    e.stopPropagation();
    saveToRedux(mainData);
    setStar(false);
    setActive([]);
    setLoc(null);
    setValue([0, 1000]);
    setRange([0, 1000]);
    setSearch(false);
    setAddressTip('');
    setActivePolyes([]);
    ref.current.reset();
    resetFilterObjects();
  };

  const areaInputChange = (val) => {
    if (val === '' && search) {
      setSearch(false);
      setLoc(null);
      ref.current.reset();
      resetFilterObjects();
      setAddressTip('');
    }
  };

  const setOnMap = (type = 'start') => {
    ref.current.reset();
    setSearch(false);
    setLoc(null);
    setAddressTip('');
    resetFilterObjects();
    setMap(true);
    setActivePoint(type);
    dispatch(setTypeMouseCursor(`cursor_finder_${type}`));
  };

  const getStep = (val) => {
    if (val[0] === 0) {
      if (val[1] < 500) {
        return 50;
      }
      if (val[1] < 700) {
        return 25;
      }
      if (val[1] < 1000) {
        return 10;
      }
    } else if (val[1] === 1000) {
      if (val[0] < 500) {
        return 50;
      }
      if (val[0] < 700) {
        return 25;
      }
      if (val[0] < 1000) {
        return 10;
      }
    }
  };

  const getTooltip = () => (
    <Tooltip
      title={tr['Click on map to set address']}
      placement="topRight"
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      <div
        className="takeFromMapIcon"
        onClick={() => takeAddressByClickMap(intl)}
        aria-hidden
      >
        <AreaFilterIcon />
      </div>
    </Tooltip>
  );

  const getActiveStartClass = () => {
    if (activePoint === 'start') {
      return 'point active';
    }
    if (startCoord) {
      return 'point done';
    }
    return 'point';
  };

  const getActiveEndClass = () => {
    if (activePoint === 'end') {
      return 'point active';
    }
    if (startCoord) {
      return 'point done';
    }
    return 'point';
  };

  return (
    <div className="filter_layout_main">
      <div className={getLayoutClass()}>
        {!suggest ? (
          <div
            className="filter_main"
            onClick={() => setVisible(!visible)}
            aria-hidden
          >
            <img src={ttf} className="ttf_img" alt="ttf_img" />
            <span className="title">{`${tr['TOURSTART TOUR FINDER']}`}</span>
            <Tooltip title={tr.Reset}>
              <ReloadOutlined
                onClick={(e) => onReset(e)}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: 22,
                  fontSize: 17,
                }}
              />
            </Tooltip>
            {!visible ? (
              <DownOutlined className="icon_arrow" />
            ) : (
              <UpOutlined className="icon_arrow" />
            )}
          </div>
        ) : null}

        <div
          style={
            visible || suggest ? { display: 'block' } : { display: 'none' }
          }
        >
          {suggest ? null : (
            <>
              <div className="filter_label">{`${tr['Search an area']}`}</div>
              <div className="filter_item" style={{ flexDirection: 'column' }}>
                <AutoCompleteAddressSearch
                  className="filterSearchAutomplete"
                  onSelect={(option) => searchOnArea(option.props)}
                  callback={(val) => areaInputChange(val)}
                  ref={ref}
                >
                  <Input
                    placeholder={tr['Region or address']}
                    allowClear
                    addonAfter={getTooltip()}
                  />
                </AutoCompleteAddressSearch>
                {search ? (
                  <span className="address_tip">{addressTip}</span>
                ) : null}
              </div>
              <Divider />
            </>
          )}
          <div className="filter_label">
            <FormattedMessage
              id="Filter by tags"
              defaultMessage="Filter by tags"
            />
          </div>
          <div className="filter_item">
            <div
              className={getItemClass(4)}
              onClick={() => onActive(4)}
              aria-hidden
            >
              <SeasideSvg />
            </div>
            <div
              className={getItemClass(2)}
              onClick={() => onActive(2)}
              aria-hidden
            >
              <MountainSvg />
            </div>
            <div
              className={getItemClass(1)}
              onClick={() => onActive(1)}
              aria-hidden
            >
              <ScenicSvg />
            </div>
            <div
              className={getItemClass(16)}
              onClick={() => onActive(16)}
              aria-hidden
            >
              <StraightSvg />
            </div>
            <div
              className={getItemClass(8)}
              onClick={() => onActive(8)}
              aria-hidden
            >
              <TwistedSvg />
            </div>
          </div>
          <Divider />
          <div className="filter_label">
            <FormattedMessage
              id="Tourstart Academy certified users"
              defaultMessage="Tourstart Academy certified users"
            />
          </div>
          <div className="filter_item">
            <div
              className={star ? 'filter_items active' : 'filter_items'}
              onClick={() => starClick()}
              aria-hidden
            >
              <StarFilledIcon />
            </div>
          </div>
          <Divider />
          <div className="filter_label">
            <FormattedMessage
              id="Filter by distance"
              defaultMessage="Filter by distance"
            />
          </div>
          <div className="filter_item">
            <Slider
              range
              min={0}
              max={1000}
              value={range}
              onChange={(value) => onChnageRange(value)}
              step={getStep(value)}
              tooltipVisible={false}
            />
            <div className="val_min">
              {value[0] > 999 ? '999+' : range[0]}
              <span>km</span>
            </div>
            <div className="val_max">
              {value[1] > 999 ? '999+' : range[1]}
              <span>km</span>
            </div>
          </div>
          {suggest ? null : (
            <>
              <Divider />

              <div className="filter_label">
                <FormattedMessage
                  id="Filter by Start and End point"
                  defaultMessage="Filter by Start and End point"
                />
              </div>

              <div className="filter_item">
                <div className="points">
                  <div
                    className={getActiveStartClass()}
                    onClick={() => setOnMap('start')}
                    aria-hidden
                  >
                    <img src={pointStart} alt="st" />
                    <div>{startCoord ? tr.Done : tr['Set Start point']}</div>
                  </div>
                  <div
                    className={getActiveEndClass()}
                    onClick={() => setOnMap('end')}
                    aria-hidden
                  >
                    <img src={pointEnd} alt="pe" />
                    <div>{endCoord ? tr.Done : tr['Set End point']}</div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default withTranslations(Filters);
